/* FE v16 — bouton « Tous nos rayons » (15/10/2026). Ouvre/ferme le panneau, change de rayon au survol, au clic ou au clavier. */
(function(){
 var r=document.querySelector('.fe15 .nav .allr');if(!r)return;
 var b=r.querySelector('.allr-btn');
 function shut(){r.classList.remove('open');b.setAttribute('aria-expanded','false');}
 b.addEventListener('click',function(){var o=r.classList.toggle('open');b.setAttribute('aria-expanded',o?'true':'false');});
 document.addEventListener('click',function(e){if(!r.contains(e.target))shut();});
 document.addEventListener('keydown',function(e){if(e.key==='Escape')shut();});
 var lis=r.parentNode.children;for(var i=0;i<lis.length;i++){if(lis[i]!==r)lis[i].addEventListener('mouseenter',shut);}
 var tabs=r.querySelectorAll('.allr-tab'),panes=r.querySelectorAll('.allr-pane');
 tabs.forEach(function(t){function on(){tabs.forEach(function(x){x.classList.toggle('on',x===t);});panes.forEach(function(p){p.classList.toggle('on',p.id===t.getAttribute('data-pane'));});}
  t.addEventListener('mouseenter',on);t.addEventListener('click',on);t.addEventListener('focus',on);});
})();